module.exports = __webpack_public_path__ + "img/clock.af5ac69c.png";